import { ApplicationState } from '../store';

// eslint-disable-next-line import/prefer-default-export
export const clientsSelector = (state: ApplicationState) =>
  state.clients?.clients || [];

export const clientsStatusSelector = (state: ApplicationState) =>
  state.clients?.status;
